export default {
    fetchingPage: false,
    adobeStatus: false,
    data : {}
}